// removed by extract-text-webpack-plugin
module.exports = {"Index":"src-pages----index-module---Index---3vhP_","Section":"src-pages----index-module---Section---3cKk9","spinAround":"src-pages----index-module---spinAround---3pFBn"};


//////////////////
// WEBPACK FOOTER
// ./src/pages/index.module.scss
// module id = 439
// module chunks = 35783957827783